import { render, staticRenderFns } from "./showDeleteMate.vue?vue&type=template&id=1ecbfc76&scoped=true&"
import script from "./showDeleteMate.vue?vue&type=script&lang=js&"
export * from "./showDeleteMate.vue?vue&type=script&lang=js&"
import style0 from "./showDeleteMate.vue?vue&type=style&index=0&id=1ecbfc76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecbfc76",
  null
  
)

export default component.exports